module.exports = __webpack_public_path__ + "img/map.7fd5c1c8.png";